import type { ApiResponse } from '@vision/ui/interfaces';
import { collectPages } from '@vision/ui/utils/pagination';

export async function collectSelectedTags<T extends { id: string }>(
  ids: string[],
  fetchPage: (ids: string[], page: number) => Promise<ApiResponse<T[]>>,
  isCancelled: () => boolean,
): Promise<T[]> {
  const items: T[] = [];
  for (let index = 0; index < ids.length && !isCancelled(); index += 50) {
    const batch = ids.slice(index, index + 50);
    const result = await collectPages((page) => fetchPage(batch, page), isCancelled);
    items.push(...result.filter((item) => batch.includes(item.id)));
  }
  return items;
}
